import { Button, Input, Typography } from '@breetometer/components';
import { ACCOUNT_NUMBER_MAX_LENGTH_FALLBACK, capitalizeFirstLetter, NUBAN_ACCOUNT_NUMBER_LENGTH } from 'BreetHelpers';
import { selectFiatMeta, useAppSelector } from 'BreetRedux';
import { type KeyboardEvent, useCallback } from 'react';

import BankSelect from '../../BankSelect';
import type { IBankSelectForm } from '../AddBeneficiary.helpers';

const BankDetailsForm = ({
	onHandleBankId,
	validatedAccountName,
	handleAccountNumber,
	accountNumberMessage,
	value,
	fetchBankDetails,
	isFetchingBankDetails,
	bankErrorMessage,
	bankId,
}: IBankSelectForm) => {
	const fetchBankDetailsOnEnter = useCallback(
		(e: KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				e.currentTarget.blur();
				fetchBankDetails?.();
			}
		},
		[fetchBankDetails]
	);

	const fiatMeta = useAppSelector(selectFiatMeta);

	const accountNumberMaxLength = fiatMeta.currency === 'NGN' ? NUBAN_ACCOUNT_NUMBER_LENGTH : ACCOUNT_NUMBER_MAX_LENGTH_FALLBACK;

	return (
		<>
			<BankSelect
				id='bank'
				label='Select Bank'
				onChange={onHandleBankId}
			/>
			{bankId && (
				<div data-testid='bank-details-form'>
					<div className='accountnumberinputsection'>
						<Input
							id=''
							label='Enter Account Number'
							widthType='full'
							placeholder=' '
							onChange={handleAccountNumber}
							errorMessage={capitalizeFirstLetter(accountNumberMessage)}
							inputMode='numeric'
							pattern='^[0-9]+$'
							maxLength={accountNumberMaxLength}
							required
							onKeyDown={fetchBankDetailsOnEnter}
							value={value}
						/>
						{!validatedAccountName && !!value && value.length >= 10 && (
							<Button
								label='Verify'
								onClick={fetchBankDetails}
								type='button'
								disabled={isFetchingBankDetails}
								isLoading={isFetchingBankDetails}
								className='theme-background-none'
							/>
						)}
					</div>

					{!!validatedAccountName && (
						<div className='validatedaccountname'>
							<Typography as='p'>{validatedAccountName}</Typography>
						</div>
					)}

					{!!bankErrorMessage && (
						<Typography
							as='p'
							className='bt_input-error-message'
						>
							{capitalizeFirstLetter(bankErrorMessage)}
						</Typography>
					)}
				</div>
			)}
		</>
	);
};

export default BankDetailsForm;
